import { Settings } from 'constants/settings';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { LegalEntity } from 'types/domain';

const CLASSIFICATION_LABEL = '501(c)(3)';

const useTaxDeductibleSettings = () => {
    const { name, settings, legalEntity, sponsoringLegalEntity, sponsorshipStatus } =
        useCurrentAccount();
    const enabledSetting = settings.find(
        item => item.code === Settings.EnableTaxDeductibility.Code,
    );
    const messageSetting = settings.find(
        item => item.code === Settings.TaxDeductibiltyMessage.Code,
    );
    const defaultMessage = `Contributions to ${name}, a 501(c)(3) organization, may be tax-deductible to the extent permitted by law. The deductible amount excludes the fair market value of any goods or services received.`;

    const is501c3 = isEntity501c3(legalEntity);
    const is501c3Sponsored =
        sponsorshipStatus === 'approved' && isEntity501c3(sponsoringLegalEntity);

    const isEditable = is501c3 || is501c3Sponsored;
    const isVisible = isEditable && !!enabledSetting?.active;

    return {
        isEditable,
        isVisible,
        defaultMessage,
        messageSetting,
        enabledSetting,
        legalEntity,
    };
};

const isEntity501c3 = (entity: LegalEntity | null) => {
    if (!entity?.classification) return false;
    return entity.status === 'approved' && entity.classification.includes(CLASSIFICATION_LABEL);
};

export { useTaxDeductibleSettings };
